import CardContainer from 'components/card/Card'
import FormSawitPoinInfo from './components/FormSawitPoinInfo'
import FormSawitPoinReceiver from './components/FormSawitPoinReceiver'
import ButtonLink from 'components/button/Button'
import useSawitPoin from './hooks/useSawitPoin'
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'

export default function SawitPoinCreate() {
  const {
    setSelectAll,
    selectAll,
    includeUsers,
    setIncludeUsers,
    excludeUsers,
    setExcludeUsers,
    listUsers,
    departmentName,
    disbursementTypes,
    fetchDisbursementTypes,
    fetchListUsers,
    currentPage,
    totalPages,
    totalUsers,
    formik,
    search,
    loadingFetch,
    loadingUser,
    setCurrentPage,
    tableContainerRef,
    onChangeUserSearch,
    toastContainer,
  } = useSawitPoin()

  const navigate = useNavigate()
  const mappingDepartment = departmentName.map(res => {
    return {
      value: res.name,
      label: res.name,
    }
  })

  const mappingDisbusmentType = disbursementTypes?.map(res => {
    return {
      value: res.id,
      label: res.name,
    }
  })

  useEffect(() => {
    fetchDisbursementTypes()
  }, [])

  useEffect(() => {
    fetchListUsers()
  }, [search, currentPage])

  return (
    <div data-testid="content-wrapper-sawitpoin-request" className="content-wrapper">
      {toastContainer}
      <CardContainer
        className="bg-transparent p-0"
        dataTestId="card-form-sawitpoin-request"
        loading={loadingFetch}
      >
        <FormSawitPoinInfo
          formData={formik}
          departmentData={mappingDepartment}
          disbursementTypes={mappingDisbusmentType}
          onDepartment={val => formik.setFieldValue('department', val)}
          onDisbursementTypeId={val => formik.setFieldValue('disbursementTypeId', val)}
          onTitle={val => formik.setFieldValue('title', val)}
          onDescription={val => formik.setFieldValue('description', val)}
          onPoint={val => formik.setFieldValue('point', val)}
          onPurpose={val => formik.setFieldValue('purpose', val)}
        />
        <div className="mt-5">
          <FormSawitPoinReceiver
            tableContainerRef={tableContainerRef}
            loading={loadingUser}
            dataSource={listUsers}
            includeUser={includeUsers}
            handleInclude={setIncludeUsers}
            excludeUser={excludeUsers}
            handleExclude={setExcludeUsers}
            selectAll={selectAll}
            handleSelectAll={setSelectAll}
            totalPages={totalPages}
            currentPage={currentPage}
            totalUsers={totalUsers}
            changePage={setCurrentPage}
            search={search}
            changeSearch={onChangeUserSearch}
          />
        </div>
        <div className="flex gap-8 mt-5 justify-end">
          <ButtonLink
            data-testid="button-undo"
            variant="outline-primary"
            block
            label="Batalkan"
            className="py-4 px-6 text-sm w-[10%]"
            onClick={() => navigate('/sawitpoin')}
          />
          <ButtonLink
            data-testid="button-add-request-sawitpoin"
            variant="solid-primary"
            block
            label="Ajukan Permintaan ke Finance"
            className="py-4 px-6 text-sm w-[25%]"
            onClick={formik.handleSubmit}
          />
        </div>
      </CardContainer>
    </div>
  )
}
